let prevScrollpos = window.screenY;
window.onscroll = function () {
    let currentScrollPos = window.scrollY;
    if (currentScrollPos <= 65) {
        document.querySelector('.header').classList.remove('header--scroll');
    } else {
        document.querySelector('.header').classList.add('header--scroll');
    }
    prevScrollpos = currentScrollPos;
};

const openingHoursBtn = document.querySelector('.openinghours__button');
const hamburgerBtn = document.querySelector('.main-nav__hamburger');
const searchBtn = document.querySelector('.search__button')

const menuOpenClass = '-menuopen';
const header = document.querySelector('.header');
const searchForm = document.querySelector('.search-page__form--header');
const searchinput = document.querySelector('#search-page__input--header');
const openingHoursOverlay = document.querySelector('.openinghours__overlay-wrapper');

window.addEventListener('keyup', (e) => {
    console.log(e.key)

    if (openingHoursBtn) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target === openingHoursBtn) {
            handleOverlay(e);
            openingHoursOverlay.focus();
        }
    
        if (e.target !== openingHoursBtn && openingHoursBtn.classList.contains('--open')) {
            handleOverlay(e);
        }
    }
})

document.addEventListener('click', (e) => {
    const openingHoursOverlay = document.querySelector('.openinghours__overlay-wrapper');

    if (openingHoursBtn) {
        if (e.target.parentElement == openingHoursBtn && !e.key) {
            handleOverlay(e);
        }

        if (!openingHoursOverlay.contains(e.target)) {
            console.log('click 3')
            if (e.target.parentElement != openingHoursBtn && openingHoursBtn.classList.contains('--open')) {
                handleOverlay(e);
            }
        }
    }

    if(e.target === searchBtn) {
        toggleSearch();
    }
})

function handleOverlay(e) {
    if(openingHoursBtn) {    
        toggleOpeningHoursOverlay(openingHoursBtn, openingHoursOverlay);
    }

    if(hamburgerBtn) {
        if(e.target == hamburgerBtn || e.target.parentElement == hamburgerBtn) {
            header.classList.remove('header--scroll');
            searchinput.blur();
            header.classList.remove('header--search');
            searchForm.style.display = 'none';
        }
    }
}

function toggleSearch() {
    header.classList.toggle('header--search');
    document.documentElement.classList.remove(menuOpenClass);
    document.body.classList.remove(menuOpenClass);

    if(header.classList.contains('header--search')) {
        searchForm.style.display = 'block';
        searchinput.focus();
    } else {
        searchForm.style.display = 'none';
    }
}

function toggleOpeningHoursOverlay(openingHoursBtn, openingHoursOverlay) {
    const header = document.querySelector('.header');

    openingHoursBtn.classList.toggle('--open');
    openingHoursOverlay.classList.toggle('--open');

    if(openingHoursOverlay.classList.contains('--open')) {
        document.body.style.overflowY = 'hidden';
    
        if(header.classList.contains('header--scroll')) {
            header.classList.remove('header--scroll');
        }
    } else {
        document.body.style.overflowY = '';
    }
}
